<template>
  <nav
    class="navbar is-fixed-top has-shadow"
    role="navigation"
    aria-label="main navigation"
    :class="(production) ? 'is-link' : 'is-warning'"
  >
    <div class="navbar-brand">
      <router-link
        :to="{ name: 'bundles' }"
        role="button"
        class="navbar-burger burger"
        active-class="is-active"
        aria-label="menu"
        aria-expanded="false"
        data-target="mainNav"
        @click="toggleNav"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </router-link>
    </div>

    <div
      id="mainNav"
      class="navbar-menu"
      :class="{ 'is-active': isActive }"
    >
      <div class="navbar-start">
        <div
          v-if="isAdmin(account)"
          class="navbar-item has-dropdown is-hoverable"
        >
          <a class="navbar-link">Beheer</a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'bundles' }"
              class="navbar-item"
              active-class="is-active"
            >
              Bundels
            </router-link>

            <router-link
              :to="{ name: 'tables'}"
              class="navbar-item"
              active-class="is-active"
            >
              Tabellen
            </router-link>

            <router-link
              :to="{ name: 'columns'}"
              class="navbar-item"
              active-class="is-active"
            >
              Kolommen
            </router-link>

            <router-link
              :to="{ name: 'list-dossiers'}"
              class="navbar-item"
              active-class="is-active"
            >
              Kwalificatiedossiers
            </router-link>

            <router-link
              :to="{ name: 'library'}"
              class="navbar-item"
              active-class="is-active"
            >
              Bibliotheek
            </router-link>

            <hr>

            <router-link
              :to="{ name: 'accounts'}"
              class="navbar-item"
              active-class="is-active"
            >
              Accounts
            </router-link>

            <router-link
              :to="{ name: 'users'}"
              class="navbar-item"
              active-class="is-active"
            >
              Gebruikers
            </router-link>

            <router-link
              :to="{ name: 'settings'}"
              class="navbar-item"
              active-class="is-active"
            >
              Instellingen
            </router-link>
          </div>
        </div>

        <router-link
          v-if="auth && hasGrant(account, 6)"
          :to="{ name: 'list-bundles' }"
          class="navbar-item"
          active-class="is-active"
        >
          Bundels
        </router-link>

        <router-link
          v-if="auth && hasGrant(account, 13)"
          :to="{ name: 'dossiers' }"
          class="navbar-item"
          active-class="is-active"
        >
          Kwalificatiedossiers
        </router-link>

        <router-link
          v-if="auth && hasGrant(account, 1)"
          :to="{ name: 'library' }"
          class="navbar-item"
          active-class="is-active"
        >
          Bibliotheek
        </router-link>
      </div>

      <div class="navbar-end">
        <div
          v-if="auth"
          class="navbar-item has-dropdown is-hoverable"
        >
          <a class="navbar-link">{{ name }}</a>

          <div class="navbar-dropdown">
            <router-link
              :to="{ name: 'my-account' }"
              class="navbar-item"
            >
              Accountgegevens
            </router-link>

            <a
              class="navbar-item"
              type="button"
              @click="signOut"
            >
              Uitloggen
            </a>
          </div>
        </div>

        <router-link
          v-else
          :to="{ name: 'sign-in' }"
          class="navbar-item"
        >
          Inloggen
        </router-link>

        <p class="navbar-item">
          <i
            class="fas fa-circle-notch fa-spin"
            :class="{ 'is-invisible': !loading }"
          ></i>
        </p>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'

export default {
  mixins: [
    authMixin
  ],

  data () {
    return {
      isActive: false
    }
  },

  computed: {
    ...mapGetters({
      auth: 'account/auth',
      account: 'account/account',
      loading: 'http/loading'
    }),

    name () {
      return `${this.account.firstname} ${this.account.lastname}`
    },

    production () {
      return !process.env.VUE_APP_API.includes('test')
    }
  },

  methods: {
    toggleNav () {
      this.isActive = !this.isActive
    },

    signOut () {
      this.$store.dispatch('account/signOut')
    },

    inPath (query) {
      return this.$route.path.includes(query)
    }
  }
}
</script>
